export var FindingObjectType;
(function (FindingObjectType) {
    FindingObjectType["FINDING_OBJECT_TYPE_PATH"] = "PATH";
    FindingObjectType["FINDING_OBJECT_TYPE_TABLE"] = "TABLE";
    FindingObjectType["FINDING_OBJECT_TYPE_DATABASE"] = "DATABASE";
})(FindingObjectType || (FindingObjectType = {}));
